import React from 'react';
import { RotationCargoOperation } from 'src/types/ViewModel/Stowage/Rotation/RotationCargoOperation';
import { useStowageStore } from 'src/context/StowageContext';
import { onSortColumn } from 'src/utils/stowage/operationListSortUtils';
import OperationListItem from './OperationListItem';

interface IFilteredOperationListProps {
    operations: RotationCargoOperation[];
    filters: string[];
}

const FilteredOperationList: React.FC<IFilteredOperationListProps> = ({ operations, filters }) => {
    const { operationListSortColumn, isOperationListSortDesc, activeStowagePlan } = useStowageStore();

    return (
        <>
            {operations
                .filter((op) => op.operationType && filters.includes(op.operationType.toLowerCase()))
                .sort((a, b) => onSortColumn(operationListSortColumn, isOperationListSortDesc, a, b, activeStowagePlan))
                .map((op) => (
                    <OperationListItem cargoOperation={op} key={'op-' + op.cargoOperationGuid} />
                ))}
        </>
    );
};

export default FilteredOperationList;
